/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  PUBLISH_NOTES_STUDY_GID_AND_PARTICIPANT_ID,
  RECEIVE_JOURNAL_PDF,
  CLOSE_JOURNAL_PDF,
  ERROR_JOURNAL_PDF
} from '../actions/actionTypes';

const initialNotesState = {
  studyGid: null,
  participantId: null,
  isFetchingPdf: false,
  pdfObjectUrl: false,
  pdfError: null
};

const noteReducer = (state = initialNotesState, action) => {
  switch (action.type) {
    case PUBLISH_NOTES_STUDY_GID_AND_PARTICIPANT_ID:
      return Object.assign({}, state, {
        studyGid: action.payload.studyGid,
        participantId: action.payload.participantId
      });
    case RECEIVE_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: false, pdfObjectUrl: action.payload.objectUrl });
    case CLOSE_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: false, pdfObjectUrl: null, pdfError: null });
    case ERROR_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: false, pdfObjectUrl: null, pdfError: action.payload });
    default:
      return state;
  }
};

export default noteReducer;
